import { Box, Button, Container, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { filterResources, storeMassAssignment, toggleFormCreateResources } from '../../../../../redux/actions/resources'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import ScreenLoading from '../../../../shared/components/ScreenLoading'
import AdminContentFilter from '../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import MassAssignmentModal from '../../../../shared/components/modals/MassAssignmentModal'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import SubHeader from '../../../../shared/styles/Subheader'
import CategoriesModal from '../components/CategoriesModal'
import CreateMediaModal from '../components/CreateMediaModal'
import ResourceModal from '../components/ResourceModal'
import ResourceTable from '../components/ResourceTable'
import ResourceTypeFilter from '../components/ResourceTypeFilter'
import useInitialState from '../hooks/useInitialState'
import useResourceFilters from '../hooks/useResourceFilters'

function AdminLibrary() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()
  useInitialState()

  const { resources, showCreateForm, showEditForm, reload, error, msg, loading } = useSelector((state: IRootState) => state.resource)
  const {
    resourcecategories: categories,
    showForm: showFormCategories,
    error: errorCategory,
    msg: msgCategory,
    loading: loadingCategory
  } = useSelector((state: IRootState) => state.resourcecategory)
  const { filters, setFilters, optionsData, handleClearFilters, handleChangeFilter } = useResourceFilters()
  const [rowsSelected, setRowsSelected] = useState<number[]>([])
  const [resourcetypeId, setResourcetypeId] = useState(1)

  const handleClickSetOptions = (options: any) => {
    setFilters({ ...filters, filterBy: options })
  }

  useEffect(() => {
    if (reload) {
      dispatch(filterResources(filters))
      setRowsSelected([])
    }
  }, [reload])

  const massEditableFields = ['countries', 'brand', 'line', 'resourcetype', 'role', 'languages', 'visibility']

  const handleSubmitMassAssignment = (data: any) => {
    dispatch(storeMassAssignment(data))
  }

  const noResults = resources.length === 0 && !loading
  const noRowsSelected = rowsSelected.length === 0
  return (
    <>
      {showEditForm && <ResourceModal />}
      {showCreateForm && <CreateMediaModal />}
      {showFormCategories && <CategoriesModal resourcetypeId={resourcetypeId} />}

      <Header title={t('admin.library.library')} />
      <SubHeader>
        <ResourceTypeFilter filters={filters} handleChangeFilter={handleChangeFilter} setResourcetypeId={setResourcetypeId} />
      </SubHeader>

      <Container maxWidth="lg">
        <Box>
          <Box mt={isMobile ? 2 : 6} gap={16} display="flex" flexDirection={isMobile ? 'column-reverse' : 'column'}>
            <Box display="flex" justifyContent="center">
              <Typography variant="h5">
                {filters.resourcetype_id === null || filters.category_id === null
                  ? t('all')
                  : categories.find((category: any) => category.id === filters.category_id)?.name}
              </Typography>
            </Box>
            <Box>
              <Grid container justifyContent="space-between" spacing={1}>
                <Grid xs={5} sm={6} sx={theme => ({ [theme.breakpoints.down('sm')]: { justifyContent: 'center' } })}>
                  {noRowsSelected && (
                    <Button
                      id="btn-create-resource"
                      variant="outlined"
                      color="secondary"
                      onClick={() => dispatch(toggleFormCreateResources())}
                    >
                      {t('admin.library.create-resource')}
                    </Button>
                  )}
                  <MassAssignmentModal rows={rowsSelected} fields={massEditableFields} handleSubmit={handleSubmitMassAssignment} />
                </Grid>
                <Grid
                  xs={7}
                  sm={6}
                  sx={theme => ({
                    display: 'flex',
                    justifyContent: 'flex-end',
                    [theme.breakpoints.down('sm')]: {
                      justifyContent: 'center'
                    }
                  })}
                >
                  <AdminContentFilter data={optionsData} handleClick={handleClickSetOptions} />
                  <CountriesFilter />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {noResults ? (
            <NotFilter subsection={null} handleClearFilters={handleClearFilters} />
          ) : (
            <Box mt={3}>
              <ResourceTable rowsSelected={rowsSelected} setRowsSelected={setRowsSelected} />
            </Box>
          )}
        </Box>
      </Container>

      <CustomSnackBar errors={[error, errorCategory]} msgs={[msg, msgCategory]} />
      <ScreenLoading loadings={[loading, loadingCategory]} />
    </>
  )
}

export default AdminLibrary
